export function addUrlParams(url, params) {
  if (!url) return;
  return `${url}?params=${encodeURIComponent(JSON.stringify(params))}`;
}
